// Module
var code = "<div class=\"arrow-up\"></div><ul><li ng-repeat=\"assigneeId in $ctrl.assigneeIds\"><ui-assignee [ui-size]=\"$ctrl.avatarSize\" from-assignee-id=\"assigneeId\" ui-name-multiline ui-name-ellipsis></ui-assignee></li></ul>";
// Exports
module.exports = code;